import script from "./SearchDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchDialog.vue?vue&type=script&setup=true&lang=js"

import "./SearchDialog.vue?vue&type=style&index=0&id=847079ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-847079ba"]])

export default __exports__